import React, { useEffect, useState } from "react";
import { useSelector } from "../../../context/AppContext";
import styled from "styled-components";
import { buildSummaryMacroInfo, buildSummaryMacroInfoV2 } from "../common/util";

const AttributeCategory = styled.div`
  font-weight: 700;
  font-size:12px;
  // text-transform: uppercase;
  color: #313131;
  margin-top: 30px;
`;
const AttributeCont = styled.div`
`;

const NiceToHavePill = styled.div`
  display: inline-block;
  background-color: #F5F5F5;
  color: #333333;
  padding:5px 10px;
  font-size: 12px;
  margin: 5px;
  border-radius: 6px;
  opacity: 0.99;
`;

const MustHavePill = styled.div`
  display: inline-block;
  background-color: #ECF4FF;
  color: #333333;
  padding: 5px 10px;
  font-size: 12px;
  margin: 5px;
  border-radius: 6px;
  opacity: 0.99;
`;

const SearchAttributes = ({ effectiveSearch }: { effectiveSearch: any }) => {
  const allMacros = useSelector((state: any) => state.attrs_state.all_macros || {});
  const [attributesMap, setAttributesMap] = useState({});

  useEffect(() => {
    if (effectiveSearch && allMacros && Object.keys(allMacros).length) {
      setAttributesMap(effectiveSearch?.mode === 'v2' ? buildSummaryMacroInfoV2(effectiveSearch, allMacros) : buildSummaryMacroInfo(effectiveSearch, allMacros));
    }
  }, [allMacros, effectiveSearch]);
  return (<>
    {/* @ts-ignore */}
    {attributesMap?.mustHaveStrs?.length > 0 && (<>
      <AttributeCategory>Must Have</AttributeCategory>
      <AttributeCont>
        {/* @ts-ignore */}
        {attributesMap?.mustHaveStrs.map((name: string) => (<>
          <MustHavePill><div dangerouslySetInnerHTML={{ __html: unescape(name) }}></div></MustHavePill>
        </>))}
      </AttributeCont>
    </>)}
    {/* @ts-ignore */}
    {attributesMap?.niceToHaveStrs?.length > 0 && (<>
      <AttributeCategory>Nice to Have</AttributeCategory>
      <AttributeCont>
        {/* @ts-ignore */}
        {attributesMap?.niceToHaveStrs.map((name: string) => (<>
          <NiceToHavePill><div dangerouslySetInnerHTML={{ __html: unescape(name) }}></div></NiceToHavePill>
        </>))}
      </AttributeCont>
    </>)}
    {/* @ts-ignore */}
    {attributesMap?.locStr?.length > 0 && (<>
      <AttributeCategory>Location</AttributeCategory>
      <AttributeCont>
        {/* @ts-ignore */}
        {attributesMap?.locStr.map((name: string) => (<>
          <MustHavePill><div dangerouslySetInnerHTML={{ __html: unescape(name) }}></div></MustHavePill>
        </>))}
      </AttributeCont>
    </>)}
  </>)
}

export default SearchAttributes;